

























































































import { Component, Vue } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings'
import AgencyRoleDto from '@/models/AgencyRoles/AgencyRoleDto'
import GiganautVue from '@/components/Shared/GiganautVue';
import AgencyRoleCreate from '@/components/AgencyRoles/AgencyRoleCreate.vue';
import AgencyRoleEdit from '@/components/AgencyRoles/AgencyRoleEdit.vue';

@Component({
  name: 'AgencyRoles',
  components: { AgencyRoleCreate, AgencyRoleEdit }
})
export default class extends GiganautVue {

    async beforeMount() {
        AgencySettingsModule.updateCurrentAgencyRole(null);
    }

    async updateCurrentAgencyRole(role: AgencyRoleDto) {
        AgencySettingsModule.updateCurrentAgencyRole(role);
    }

    get currentAgencyRole() {
        return AgencySettingsModule.currentAgencyRole;
    }

    get loadingAgencyRoles() {
        return AgencySettingsModule.loadingAgencyRoles;
    }

    get agencyRoles() {
        return AgencySettingsModule.agencyRoles;
    }

    get permissionRows() {
        if (!this.currentAgencyRole) return [];
        const role = this.currentAgencyRole;
        return [
            { label: 'Workers', value: role.permissionWorkers },
            { label: 'Companies', value: role.permissionCompanies },
            { label: 'Locations', value: role.permissionLocations },
            { label: 'Contacts', value: role.permissionContacts },
            { label: 'Bookings', value: role.permissionBookings },
            { label: 'Jobs', value: role.permissionJobs },
            { label: 'Opportunities', value: role.permissionOpportunities },
            { label: 'Payroll', value: role.permissionPayroll },
            { label: 'Spec Outs', value: role.permissionSpecOuts },
            { label: 'Invoices', value: role.permissionInvoices },
            { label: 'Timesheets', value: role.permissionTimesheets },
            { label: 'Campaigns', value: role.permissionCampaigns },
            { label: 'Messaging', value: role.permissionMessaging },
            { label: 'Reports', value: role.permissionReports },
            { label: 'Activities', value: role.permissionActivities },
            { label: 'Compliance', value: role.permissionCompliance },
            { label: 'KPIs', value: role.permissionKpis },
            // Agency section
            { label: 'Settings: Agency Profile', value: role.permissionSettingsAgencyProfile },
            { label: 'Settings: Branches', value: role.permissionSettingsBranches },
            { label: 'Settings: Rate Cards', value: role.permissionSettingsRateCards },
            { label: 'Settings: Uniforms', value: role.permissionSettingsUniforms },
            { label: 'Settings: Reporting Periods', value: role.permissionSettingsReportingPeriods },
            { label: 'Settings: KPIs', value: role.permissionSettingsKpis },
            // Users & Permissions section
            { label: 'Settings: Users', value: role.permissionSettingsUsers },
            { label: 'Settings: Groups', value: role.permissionSettingsGroups },
            { label: 'Settings: Roles', value: role.permissionSettingsRoles },
            // Communication section
            { label: 'Settings: Email Templates', value: role.permissionSettingsEmailTemplates },
            { label: 'Settings: Conversation Topics', value: role.permissionSettingsConversationTopics },
            { label: 'Settings: Business Hours', value: role.permissionSettingsBusinessHours },
            // Categories section
            { label: 'Settings: Note Categories', value: role.permissionSettingsNoteCategories },
            { label: 'Settings: Activity Categories', value: role.permissionSettingsActivityCategories },
            // Work Types section
            { label: 'Settings: Industries', value: role.permissionSettingsIndustries },
            { label: 'Settings: Location Types', value: role.permissionSettingsLocationTypes },
            { label: 'Settings: Skills', value: role.permissionSettingsSkills },
            { label: 'Settings: Qualifications', value: role.permissionSettingsQualifications },
            { label: 'Settings: Positions', value: role.permissionSettingsPositions },
            // Integrations section
            { label: 'Settings: Integrations', value: role.permissionSettingsIntegrations },
            { label: 'Settings: Mobile App', value: role.permissionSettingsMobileApp },
            // Sales / Pipeline section
            { label: 'Settings: Opportunity Sources', value: role.permissionSettingsOpportunitySources },
            { label: 'Settings: Opportunity Lost Reasons', value: role.permissionSettingsOpportunityLostReasons },
        ];
    }

    permissionLevelText(level: number): string {
        switch (level) {
            case 1: return 'View';
            case 2: return 'Manage';
            default: return 'None';
        }
    }
}
